/** Muted by default; brand red with a small nudge on hover or keyboard focus. */
export const footerLinkSx = {
  color: 'text.secondary',
  textDecoration: 'none',
  display: 'inline-block',
  transition: 'color 150ms, transform 150ms',
  '&:hover, &:focus-visible': { color: 'primary.main', transform: 'translateX(2px)' },
} as const;
